import React, { Component } from "react";
import { Row, Col,  Card, CardBody, } from "reactstrap";
import PanelHeader from "components/PanelHeader/PanelHeader";
import ScaleLoader from "react-spinners/ScaleLoader";
import LoadingOverlay from 'react-loading-overlay'; 
import DataBindingComponent from '../../views/WidgetLayout/DataBindingComponent';
import { APIRESPONSE } from "settings/shared/constants";
import SettingsService from "services/api/Setting";
import Scrollbars from "react-custom-scrollbars";

class WidgetLayout extends Component {
    constructor(props) {
        super(props);
        this.state = {
            cardData: [],
            sheight: window.innerHeight
        }
    }

    componentDidMount() {
        this.getWidgetData();    
    }


    getWidgetData = () => {
        this.setState({loading : true})
        setTimeout(() => {
            SettingsService.getDashboardInfo(localStorage.getItem("dashboardId"))
            .then((response) => {
                if (response.status === APIRESPONSE.SUCCESS) {
                    let widgetsDTOS = response.widgetsDTOS;
                    this.setState({
                        cardData: widgetsDTOS,
                        loading :false
                    })
                }else{
                    this.setState({
                        cardData: [],
                        loading :false
                    })
                }
            })
        },2000)
        
    }

    resetValue  = () =>{
        this.setState({
            cardData : []
        },()=>{
            this.getWidgetData();
        })
    }

    _onChangeValueData = (index, bindData) =>{
        if (index !== undefined && bindData !== undefined && bindData.length > 0) {
            this.state.cardData[index].widgetData[0].bind["data"] = bindData[0];
            this.setState({
                loading : false
            })  
        }
    }


    render() {
        return (
            <>
       
                <PanelHeader
                    content={
                        <div className="header text-center">
                        </div>
                    }
                />
                <div className="content">
                    <LoadingOverlay
                        active={this.state.loading}
                        spinner={<ScaleLoader
                            height={35}
                            width={5}
                            radius={2}
                            margin={2}
                            color={"#123abc"}
                            loading={this.state.loading}
                        />}
                    >
                        <Row>
                            <Col xs={12} md={12}>

                                <Card className="wd-card-main">
                                <Scrollbars autoHeight autoHeightMin={this.state.sheight}>
                                    <div className="sticky-wraper border-bottom d-flex justify-content-between p-3 pb-3">
                                        <span className="h5 font-weight-bold p-0 m-0">{window.location.pathname.split("/").pop()}</span>
                                        {this.state.cardData !== null && this.state.cardData.length > 0 && <span className="font-weight-bold text-primary actionicon"
                                        onClick={e => this.resetValue()}><i className="fas fa-sync-alt"></i> &nbsp;Reload</span>}
                                    </div>
                                    <CardBody>
                                        <div className="main-wrapper">
                                            <div className="main-wid">
                                                {this.state.cardData !== null && this.state.cardData.length > 0 && this.state.cardData.map((dtosItem, index) => (
                                                         dtosItem.widgetData !== null && <div key={index} className="sub-wid mb-5 ml-3 mr-3" style={{width: dtosItem.widgetData[0].width + "%"}}>
                                                         <DataBindingComponent 
                                                            widgetItem={dtosItem.widgetData[0]}
                                                            updateIndex = {index}
                                                            _onChangeValueData = {this._onChangeValueData.bind(this)}

                                                         />
                                                    </div>
                                                ))}
                                                  {this.state.cardData === null && 
                                                 <span className="d-block text-center w-100 font16"> No Widgets Found </span>
                                                }
                                            </div>
                                        </div>
                                    </CardBody>
                                    </Scrollbars>

                                </Card>
                            </Col>
                        </Row>
                    </LoadingOverlay>
                </div>


            </>
        )
    }
}


export default WidgetLayout;